import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import { Button, Col, Flex } from 'antd';

import { PlusOutlined } from '@ant-design/icons';

import RenderIf from '@common/RenderIf';
import { TPanelContainer } from '@molecules/sidePanelSelect';
import { StyledRow } from '@pages/objects/common/components';

import { Entries } from './components/Entries';
import { Footer } from './components/Footer';
import { Header } from './components/Header';

import './objectProfile.scss';

/** Значение характеристики объекта: id выбранного варианта либо введённый текст. */
type TFieldValue = string | number;

type TProps = {
    /** Категория объекта в режиме создания, id объекта — в остальных */
    objectId?: number | null;
    mode?: 'create' | null;
    /**
     * Поля формы поднимаются наружу: создаёт объект не сама карточка, а владелец —
     * модалка создания заказа, смены клиента или выбора объекта.
     */
    setExternalObjectName?: (name: string) => void;
    setExternalSelectedValues?: (values: Record<string, TFieldValue>) => void;
    setExternalValueLabels?: (labels: Record<string, TFieldValue>) => void;
    setExternalItemsRef?: (items: unknown[]) => void;
    /**
     * Шапка с фотографией и названием. В модалках её нет: там карточка — лишь часть
     * шага мастера, и крупный блок съедает высоту, которой на телефоне и так мало.
     */
    withHeader?: boolean;
    /**
     * Границы панели вариантов характеристики. В модалках передают саму модалку,
     * иначе панель разворачивается по ближайшей найденной или по окну.
     */
    panelContainer?: TPanelContainer;
};

export const ObjectProfile = ({
    objectId = null,
    mode = null,
    setExternalObjectName = () => {},
    setExternalSelectedValues = () => {},
    setExternalValueLabels = () => {},
    setExternalItemsRef = () => {},
    withHeader = true,
    panelContainer,
}: TProps) => {
    const [objectName, setObjectName] = useState('');

    useEffect(() => {
        setExternalObjectName(objectName);
    }, [objectName]);
    return (
        <Flex vertical gap={15} style={{ overflow: 'hidden', padding: '10px 5px' }}>
            <RenderIf condition={withHeader}>
                <StyledRow offset={10}>
                    <Header objectName={objectName} setObjectName={setObjectName} />
                </StyledRow>
            </RenderIf>
            <RenderIf condition={!withHeader}>
                {/* Замена шапке в модалках: занимает одну строку вместо крупного
                    блока с фотографией. Обработчика пока нет — загрузить фото
                    объекта некуда: POST /files принимает только product, service,
                    user, resource и brigade, на остальное отвечает 404 */}
                <StyledRow offset={10}>
                    <Col span={24}>
                        <Button block icon={<PlusOutlined />}>
                            Фото
                        </Button>
                    </Col>
                </StyledRow>
            </RenderIf>
            <StyledRow offset={10}>
                <Entries
                    objectName={objectName}
                    setObjectName={setObjectName}
                    objId={objectId}
                    setExternalValueLabels={setExternalValueLabels}
                    setExternalSelectedValues={setExternalSelectedValues}
                    setExternalItemsRef={setExternalItemsRef}
                    customMode={mode}
                    panelContainer={panelContainer}
                />
            </StyledRow>
            <StyledRow offset={12}>
                <Footer objectName={objectName} />
            </StyledRow>
        </Flex>
    );
};
